import { Checkbox, Form, Input } from "antd";
import React, { useState } from "react";

const admissionOptions = [
  { label: "Neuro Rehabilitation", value: "neuro_rehabilitation" },
  {
    label: "Cardio Pulmonary Rehabilitation",
    value: "cardio_pulmonary_rehabilitation",
  },
  { label: "Palliative Care", value: "palliative_care" },
  { label: "Cancer Rehabilitation", value: "cancer_rehabilitation" },
  { label: "Transitional Care", value: "transitional_care" },
  { label: "Ortho Rehabilitation", value: "ortho_rehabilitation" },
  { label: "Others", value: "others" },
];
const AdmissionFor = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  const others = form.getFieldValue("admission_for")?.includes("others");

  return (
    <>
      <Form.Item name={"admission_for"}>
        <Checkbox.Group
          options={admissionOptions}
          onChange={() => setRefresh((prev) => !prev)}
        />
      </Form.Item>
      {others && (
        <>
          <Form.Item name={"others_description"}>
            <Input placeholder="Please enter the description" />
          </Form.Item>
        </>
      )}
    </>
  );
};

export default AdmissionFor;
